export default __webpack_public_path__ + "static/media/alert-triangle-orange.3cee6a05.svg";